import "../pages/Css/global.css"


const Discount = () => {
    return <div></div>;
};

export default Discount;